module.exports = __webpack_public_path__ + "img/60c46e5fba5825.76009464.66c029b7.png";